import script from "./MedicaidTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./MedicaidTable.vue?vue&type=script&setup=true&lang=ts"

import "./MedicaidTable.vue?vue&type=style&index=0&id=dfdd9a84&lang=scss"

const __exports__ = script;

export default __exports__